"use client";
//#region packages/@mantine/core/src/components/Tooltip/Tooltip.module.css
var Tooltip_module_default = {
	"tooltip": "m_1b3c8819",
	"arrow": "m_f898399f"
};
//#endregion
export { Tooltip_module_default as default };

//# sourceMappingURL=Tooltip.module.mjs.map